module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-panel', [_c('h2', [_vm._v("Vision mission donation")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.confirmAmount()
      }
    }
  }, [_c('p', [_vm._v("\n                    Thank you for deciding to donate to Vision Mission. "), _c('br'), _vm._v(" \n                    By donating you help others enjoy a great movie experience.\n                ")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('sk-combo-select', {
    staticClass: "form-group",
    attrs: {
      "options": _vm.items,
      "label": "Price",
      "searchable": false,
      "placeholder": "Choose an amount",
      "multiple": false,
      "track-by": "Price",
      "validationValue": _vm.selected_concession ? _vm.selected_concession.Price : '',
      "error-message": "Please choose a month",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [
          [_c('span', {
            staticClass: "option__title"
          }, [_vm._v(_vm._s(props.option.Price))])]
        ]
      }
    }]),
    model: {
      value: (_vm.selected_concession),
      callback: function($$v) {
        _vm.selected_concession = $$v
      },
      expression: "selected_concession"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Minimum donation amount R 100")])], 1)], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Confirm Amount")]), _vm._v("\n                     \n                    "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAlert = true
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.cancelAlert),
      callback: function($$v) {
        _vm.cancelAlert = $$v
      },
      expression: "cancelAlert"
    }
  }, [_c('p', [_vm._v("Are you sure you want to cancel your donation?")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAlert = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("I'm sure")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8f83a0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/donate/choose-amount/choose-amount.vue
// module id = 858
// module chunks = 0